import script from "./primaryButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./primaryButton.vue?vue&type=script&setup=true&lang=ts"

import "./primaryButton.vue?vue&type=style&index=0&id=21238c7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21238c7c"]])

export default __exports__